import styled, { css } from "styled-components";
import { border, borderRadius, color, nativeFocusRing, onHover, transition, typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
import { NakedButton } from "../../naked-button/NakedButton";
const ICON_WIDTH = "26px";
export const EditableText = styled.div `
  ${(props) => typeStyle(props.typeStyle)};
  color: ${color("typeBody")};
  position: relative;

  input {
    ${(props) => typeStyle(props.typeStyle)};
    color: ${color("typeBody")};
    border-radius: ${borderRadius("extraLarge")};
  }
`;
export const EditButton = styled(NakedButton) `
  min-width: ${ICON_WIDTH};
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% + 2px);
  opacity: 0.5;
  transition: ${transition("base", "opacity")};
  cursor: text;

  :focus {
    outline: none; // handled with :focus-within on Preview
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;
/** NOTE: padding of the edit button should match default input padding to prevent jank. */
const INPUT_V_PADDING = units(0.375);
const INPUT_H_PADDING = units(0.75);
const hoverStyles = css `
  padding-left: ${INPUT_H_PADDING};
  border-color: ${color("inputBorder")};
  ${EditButton} {
    opacity: 1;
  }
  span {
    opacity: 1;
    border-color: ${color("inputBorder")};
  }
`;
export const Preview = styled.span `
  ${(props) => typeStyle(props.typeStyle)};
  color: ${color("typeBody")};
  vertical-align: bottom;
  width: auto;
  max-width: calc(100% - ${ICON_WIDTH});
  display: inline-flex; // this used to be a button and does not need to auto fill the container, needs to have dynamic width
  position: relative;
  margin: 0;
  transition:
    padding-left 0.1s ease,
    border-color 0.1s ease,
    opacity 0.3s ease;
  padding: 0;
  border: 1px solid transparent;
  border-radius: ${borderRadius("extraLarge")};
  justify-content: start;
  align-items: center;

  ${EditButton} {
    opacity: 0;
  }

  [data-whatinput="keyboard"] &:focus-within {
    ${nativeFocusRing()}

    ${hoverStyles}
  }

  ${onHover(hoverStyles)}
`;
const PreviewBase = styled.span ``;
export const PreviewText = styled(PreviewBase) `
  border-right: 1px solid transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: ${INPUT_V_PADDING} ${INPUT_H_PADDING} ${INPUT_V_PADDING} 0;
  ${({ hasValue, hasPlaceholder }) => hasValue === false &&
    hasPlaceholder &&
    css `
      color: ${color("typeMeta")};
    `};
`;
export const ReadOnlyPreview = styled(PreviewBase) `
  ${(props) => typeStyle(props.typeStyle)};
`;
const ACTION_HEIGHT = 36;
export const InputActionWrapper = styled.div `
  background-color: ${color("container")};
  box-shadow:
    0 2px 6px 0 rgba(0, 0, 0, 0.12),
    0 2px 5px 0 rgba(0, 0, 0, 0.18);
  display: flex;
  position: absolute;
  bottom: -${ACTION_HEIGHT}px;
  right: 0;
  z-index: 11;
  border-radius: ${borderRadius("extraExtraLarge")};

  button {
    min-width: ${units(5)};
  }

  button:first-of-type {
    border-right: ${border()};
  }

  ${({ isVisuallyHidden }) => (isVisuallyHidden ? visuallyHidden() : undefined)}
`;
export const InputActionButton = styled(NakedButton) `
  display: flex;
  cursor: pointer;
  color: ${color("typeBody")};
  height: ${ACTION_HEIGHT}px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
